export default "__VITE_ASSET__Bd4EAZH8__"